import { SET_TOAST_ERROR, SET_TOAST_SUCCESS } from './actionTypes';

export const setErrorToast = error => ({
    type: SET_TOAST_ERROR,
    payload: error
});

export const setSuccessToast = error => ({
    type: SET_TOAST_SUCCESS,
    payload: error
});
